import styled, {useTheme} from 'styled-components';
import React from 'react';
import capsize from 'capsize';
import maybeHandleLineBreaks from '../../utils/maybeHandleLineBreaks';

const fontMetrics = {
  Lato: {
    capHeight: 1433,
    ascent: 1974,
    descent: -426,
    lineGap: 0,
    unitsPerEm: 2000,
    // xHeight: 1013,
  },
  'Noto Serif Display': {
    capHeight: 1462,
    ascent: 2189,
    descent: -600,
    lineGap: 0,
    unitsPerEm: 2048,
    // xHeight: 1098,
  },
  'Work Sans': {
    capHeight: 660,
    ascent: 930,
    descent: -243,
    lineGap: 0,
    unitsPerEm: 1000,
  },
};

export default function Text({
  size = 'standard',
  weight = 'regular',
  align = 'left',
  clamp = 0,
  lineGap = 1.75,
  fontFamily = null,
  children,
  ...props
}) {

  const theme = useTheme();

  return (
    <Element size={size} align={align} weight={weight} clamp={clamp} lineGap={lineGap} fontFamily={fontFamily ?? theme.tokens.typography.fontFamily.body} {...props}>
      {clamp === 0 ? (
        maybeHandleLineBreaks(children)
      ) : (
        <Truncate clamp={clamp}>{maybeHandleLineBreaks(children)}</Truncate>
      )}
    </Element>
  )
}

// @todo 2020-05-08 extract
const alignments = {
  left: 'start',
  center: 'center',
  right: 'end',
};

// @todo 2021-04-19 extract into tokens.js
//   or make it dynamic: parseFloat(getComputedStyle(document.documentElement).fontSize)
const BASE_FONT_SIZE = 16;

const Element = styled.span`
  ${props => (
    capsize({
      fontMetrics: fontMetrics[props.fontFamily],
      fontSize: props.theme.tokens.text[props.size] * BASE_FONT_SIZE,
      lineGap: props.theme.tokens.text[props.size] * BASE_FONT_SIZE * (props.lineGap - 1),
    })
  )};

  display: block;
  text-align: ${props => alignments[props.align]};
  font-weight: ${props => props.theme.tokens.textWeight[props.weight]};
  font-family: ${props => props.fontFamily};
`;

const Truncate = styled.span`
  display: -webkit-box;
  -webkit-line-clamp: ${props => props.clamp};
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
